import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  Facebook, 
  Linkedin, 
  Youtube, 
  Instagram, 
  ArrowRight, 
  Globe, 
  ChevronDown 
} from 'lucide-react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Action d'abonnement à la newsletter
  };

  return (
    <footer className="bg-[#040914] text-slate-400 text-xs font-sans border-t border-slate-900/60 pt-12 pb-8 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        
        {/* SECTION PRINCIPALE / GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-6 pb-12">
          
          {/* Colonne 1 : Brand & Reseaux (3 cols) */}
          <div className="lg:col-span-3 space-y-4">
            <Link to="/" className="inline-block">
              {/* Remplace le src par ton chemin d'image de logo blanc */}
              <img 
                src="/logo1.png" 
                alt="IZI Call Center" 
                className="h-8 w-auto object-contain brightness-0 invert" 
              />
            </Link>
            
            <p className="text-slate-400 text-xs leading-relaxed max-w-xs">
              La plateforme cloud tout-en-un pour une relation client exceptionnelle.
            </p>

            {/* Icones Réseaux Sociaux */}
            <div className="flex items-center gap-2.5 pt-2">
              <a 
                href="#facebook" 
                className="p-1.5 rounded-full border border-slate-700/80 text-slate-300 hover:text-white hover:border-white transition-all"
                aria-label="Facebook"
              >
                <Facebook size={14} />
              </a>
              <a 
                href="#linkedin" 
                className="p-1.5 rounded-full border border-slate-700/80 text-slate-300 hover:text-white hover:border-white transition-all"
                aria-label="LinkedIn"
              >
                <Linkedin size={14} />
              </a>
              <a 
                href="#youtube" 
                className="p-1.5 rounded-full border border-slate-700/80 text-slate-300 hover:text-white hover:border-white transition-all"
                aria-label="YouTube"
              >
                <Youtube size={14} />
              </a>
              <a 
                href="#instagram" 
                className="p-1.5 rounded-full border border-slate-700/80 text-slate-300 hover:text-white hover:border-white transition-all"
                aria-label="Instagram"
              >
                <Instagram size={14} />
              </a>
            </div>
          </div>

          {/* Colonne 2 : Produit (2 cols) */}
          <div className="lg:col-span-2 space-y-3">
            <h3 className="text-sm font-semibold text-white">Produit</h3>
            <ul className="space-y-2.5">
              <li><Link to="/fonctionnalites" className="hover:text-white transition-colors">Fonctionnalités</Link></li>
              <li><Link to="/telephonie-cloud" className="hover:text-white transition-colors">Téléphonie Cloud</Link></li>
              <li><Link to="/ia-gaston" className="hover:text-white transition-colors">IA Gaston</Link></li>
              <li><Link to="/integrations" className="hover:text-white transition-colors">Intégrations</Link></li>
              <li><Link to="/securite" className="hover:text-white transition-colors">Sécurité</Link></li>
            </ul>
          </div>

          {/* Colonne 3 : Solutions (2 cols) */}
          <div className="lg:col-span-2 space-y-3">
            <h3 className="text-sm font-semibold text-white">Solutions</h3>
            <ul className="space-y-2.5">
              <li><Link to="/centres-de-contact" className="hover:text-white transition-colors">Centres de contact</Link></li>
              <li><Link to="/televente" className="hover:text-white transition-colors">Télévente</Link></li>
              <li><Link to="/support-client" className="hover:text-white transition-colors">Support client</Link></li>
              <li><Link to="/recouvrement" className="hover:text-white transition-colors">Recouvrement</Link></li>
            </ul>
          </div>

          {/* Colonne 4 : Ressources (2 cols) */}
          <div className="lg:col-span-2 space-y-3">
            <h3 className="text-sm font-semibold text-white">Ressources</h3>
            <ul className="space-y-2.5">
              <li><Link to="/guides" className="hover:text-white transition-colors">Guides</Link></li>
              <li><Link to="/api" className="hover:text-white transition-colors">API</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/documentation" className="hover:text-white transition-colors">Documentation</Link></li>
            </ul>
          </div>

          {/* Colonne 5 : À propos (1 col) */}
          <div className="lg:col-span-1 space-y-3">
            <h3 className="text-sm font-semibold text-white whitespace-nowrap">À propos</h3>
            <ul className="space-y-2.5">
              <li><Link to="/qui-sommes-nous" className="hover:text-white transition-colors whitespace-nowrap">Qui sommes-nous ?</Link></li>
              <li><Link to="/carrieres" className="hover:text-white transition-colors">Carrières</Link></li>
              <li><Link to="/presse" className="hover:text-white transition-colors">Presse</Link></li>
              <li><Link to="/partenaires" className="hover:text-white transition-colors">Partenaires</Link></li>
            </ul>
          </div>

          {/* Colonne 6 : Newsletter (2 cols sur grands écrans) */}
          <div className="lg:col-span-2 space-y-3">
            <h3 className="text-sm font-semibold text-white">Restez informé</h3>
            <p className="text-slate-400 text-xs">
              Recevez nos dernières actualités et conseils.
            </p>
            
            <form onSubmit={handleSubmit} className="pt-1">
              <div className="relative flex items-center bg-white rounded-xl p-1 shadow-sm">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Votre email professionnel"
                  required
                  className="w-full bg-transparent px-3 py-1.5 text-xs text-slate-800 placeholder-slate-400 focus:outline-none"
                />
                <button
                  type="submit"
                  className="bg-[#0066FF] hover:bg-blue-600 text-white p-2 rounded-lg transition-colors flex-shrink-0"
                  aria-label="S'abonner"
                >
                  <ArrowRight size={14} />
                </button>
              </div>
            </form>
          </div>

        </div>

        {/* BOTTOM BAR / MENTIONS LÉGALES */}
        <div className="pt-8 border-t border-slate-900/80 flex flex-col md:flex-row items-center justify-between gap-4 text-[11px] text-slate-400">
          <div>
            © 2024 IZI Call Center. Tous droits réservés.
          </div>

          <div className="flex flex-wrap items-center gap-6">
            <Link to="/mentions-legales" className="hover:text-white transition-colors">
              Mentions légales
            </Link>
            <Link to="/politique-de-confidentialite" className="hover:text-white transition-colors">
              Politique de confidentialité
            </Link>
            <Link to="/conditions-d-utilisation" className="hover:text-white transition-colors">
              Conditions d'utilisation
            </Link>
            
            {/* Langue */}
            <button className="flex items-center gap-1.5 text-slate-300 hover:text-white transition-colors ml-2">
              <Globe size={13} />
              <span>Français</span>
              <ChevronDown size={12} />
            </button>
          </div>
        </div>

      </div>
    </footer>
  );
}